// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/people/v1/people.v1.proto (package no.jotta.openapi.people.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from message no.jotta.openapi.people.v1.Person
 */
export class Person extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * @generated from field: string thumb_url = 2;
     */
    thumbUrl = "";
    /**
     * @generated from field: string thumb_encoded_content_ref = 4;
     */
    thumbEncodedContentRef = "";
    /**
     * @generated from field: optional string name = 3;
     */
    name;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.Person";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "thumb_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "thumb_encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new Person().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Person().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Person().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Person, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.Bounds
 */
export class Bounds extends Message {
    /**
     * @generated from field: double left = 1;
     */
    left = 0;
    /**
     * @generated from field: double top = 2;
     */
    top = 0;
    /**
     * @generated from field: double right = 3;
     */
    right = 0;
    /**
     * @generated from field: double bottom = 4;
     */
    bottom = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.Bounds";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "left", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
        { no: 2, name: "top", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
        { no: 3, name: "right", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
        { no: 4, name: "bottom", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    ]);
    static fromBinary(bytes, options) {
        return new Bounds().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Bounds().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Bounds().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Bounds, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPersonRequest
 */
export class GetPersonRequest extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPersonRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetPersonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPersonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPersonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPersonRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPersonResponse
 */
export class GetPersonResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.people.v1.Person person = 1;
     */
    person;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPersonResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person", kind: "message", T: Person },
    ]);
    static fromBinary(bytes, options) {
        return new GetPersonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPersonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPersonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPersonResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPhotosWithPersonRequest
 */
export class GetPhotosWithPersonRequest extends Message {
    /**
     * @generated from field: string person_id = 1;
     */
    personId = "";
    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor;
    /**
     * @generated from field: optional uint32 page_size = 3;
     */
    pageSize;
    /**
     * @generated from field: optional bool debug = 999;
     */
    debug;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPhotosWithPersonRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 3, name: "page_size", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 999, name: "debug", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetPhotosWithPersonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPhotosWithPersonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPhotosWithPersonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPhotosWithPersonRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPhotosWithPersonResponse
 */
export class GetPhotosWithPersonResponse extends Message {
    /**
     * @generated from field: optional string cursor = 1;
     */
    cursor;
    /**
     * @generated from field: repeated no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo photo = 2;
     */
    photo = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPhotosWithPersonResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 2, name: "photo", kind: "message", T: GetPhotosWithPersonResponse_Photo, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetPhotosWithPersonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPhotosWithPersonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPhotosWithPersonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPhotosWithPersonResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo
 */
export class GetPhotosWithPersonResponse_Photo extends Message {
    /**
     * @generated from field: string md5 = 1;
     */
    md5 = "";
    /**
     * @generated from field: string thumb_url = 2;
     */
    thumbUrl = "";
    /**
     * @generated from field: string encoded_content_ref = 3;
     */
    encodedContentRef = "";
    /**
     * @generated from field: optional string cursor = 4;
     */
    cursor;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "md5", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "thumb_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetPhotosWithPersonResponse_Photo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPhotosWithPersonResponse_Photo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPhotosWithPersonResponse_Photo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPhotosWithPersonResponse_Photo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetFacesInPhotoRequest
 */
export class GetFacesInPhotoRequest extends Message {
    /**
     * @generated from field: string md5 = 1;
     */
    md5 = "";
    /**
     * @generated from field: optional bool debug = 999;
     */
    debug;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetFacesInPhotoRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "md5", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 999, name: "debug", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetFacesInPhotoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFacesInPhotoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFacesInPhotoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFacesInPhotoRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetFacesInPhotoResponse
 */
export class GetFacesInPhotoResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto face = 1;
     */
    face = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetFacesInPhotoResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "face", kind: "message", T: GetFacesInPhotoResponse_FaceInPhoto, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetFacesInPhotoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFacesInPhotoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFacesInPhotoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFacesInPhotoResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto
 */
export class GetFacesInPhotoResponse_FaceInPhoto extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug debug = 999;
     */
    debug;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto";
    static fields = proto3.util.newFieldList(() => [
        { no: 999, name: "debug", kind: "message", T: GetFacesInPhotoResponse_FaceInPhoto_Debug, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetFacesInPhotoResponse_FaceInPhoto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFacesInPhotoResponse_FaceInPhoto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFacesInPhotoResponse_FaceInPhoto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFacesInPhotoResponse_FaceInPhoto, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug
 */
export class GetFacesInPhotoResponse_FaceInPhoto_Debug extends Message {
    /**
     * @generated from field: no.jotta.openapi.people.v1.Bounds bounds = 1;
     */
    bounds;
    /**
     * @generated from field: string face_thumb_url = 3;
     */
    faceThumbUrl = "";
    /**
     * @generated from field: optional no.jotta.openapi.people.v1.Person person = 2;
     */
    person;
    /**
     * @generated from field: map<string, string> metadata = 4;
     */
    metadata = {};
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "bounds", kind: "message", T: Bounds },
        { no: 3, name: "face_thumb_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "person", kind: "message", T: Person, opt: true },
        { no: 4, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    ]);
    static fromBinary(bytes, options) {
        return new GetFacesInPhotoResponse_FaceInPhoto_Debug().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFacesInPhotoResponse_FaceInPhoto_Debug().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFacesInPhotoResponse_FaceInPhoto_Debug().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFacesInPhotoResponse_FaceInPhoto_Debug, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPeopleRequest
 */
export class GetPeopleRequest extends Message {
    /**
     * @generated from field: optional string cursor = 1;
     */
    cursor;
    /**
     * @generated from field: optional uint32 page_size = 2;
     */
    pageSize;
    /**
     * @generated from field: optional bool debug = 999;
     */
    debug;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPeopleRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 2, name: "page_size", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 999, name: "debug", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetPeopleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeopleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeopleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeopleRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPeopleResponse
 */
export class GetPeopleResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.people.v1.Person persons_deprecated = 1;
     */
    personsDeprecated = [];
    /**
     * @generated from field: repeated no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson persons = 3;
     */
    persons = [];
    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPeopleResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "persons_deprecated", kind: "message", T: Person, repeated: true },
        { no: 3, name: "persons", kind: "message", T: GetPeopleResponse_PagedPerson, repeated: true },
        { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetPeopleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeopleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeopleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeopleResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson
 */
export class GetPeopleResponse_PagedPerson extends Message {
    /**
     * @generated from field: no.jotta.openapi.people.v1.Person person = 1;
     */
    person;
    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person", kind: "message", T: Person },
        { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetPeopleResponse_PagedPerson().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeopleResponse_PagedPerson().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeopleResponse_PagedPerson().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeopleResponse_PagedPerson, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.PatchPersonRequest
 */
export class PatchPersonRequest extends Message {
    /**
     * @generated from field: string person_id = 1;
     */
    personId = "";
    /**
     * @generated from field: optional string name = 2;
     */
    name;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.PatchPersonRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new PatchPersonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchPersonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchPersonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchPersonRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.PatchPersonResponse
 */
export class PatchPersonResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.people.v1.Person person = 1;
     */
    person;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.PatchPersonResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person", kind: "message", T: Person },
    ]);
    static fromBinary(bytes, options) {
        return new PatchPersonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchPersonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchPersonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchPersonResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetMergeCandidatesRequest
 */
export class GetMergeCandidatesRequest extends Message {
    /**
     * @generated from field: string person_id = 1;
     */
    personId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetMergeCandidatesRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetMergeCandidatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMergeCandidatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMergeCandidatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMergeCandidatesRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetMergeCandidatesResponse
 */
export class GetMergeCandidatesResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate merge_candidate = 1;
     */
    mergeCandidate = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetMergeCandidatesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "merge_candidate", kind: "message", T: GetMergeCandidatesResponse_MergeCandidate, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetMergeCandidatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMergeCandidatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMergeCandidatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMergeCandidatesResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate
 */
export class GetMergeCandidatesResponse_MergeCandidate extends Message {
    /**
     * @generated from field: no.jotta.openapi.people.v1.Person person = 1;
     */
    person;
    /**
     * @generated from field: double similarity_score = 2;
     */
    similarityScore = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person", kind: "message", T: Person },
        { no: 2, name: "similarity_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetMergeCandidatesResponse_MergeCandidate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMergeCandidatesResponse_MergeCandidate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMergeCandidatesResponse_MergeCandidate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMergeCandidatesResponse_MergeCandidate, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.MergePeopleRequest
 */
export class MergePeopleRequest extends Message {
    /**
     * The target person that other people will be merged into. The merged result is guaranteed to remain stable.
     *
     * @generated from field: string target_person_id = 2;
     */
    targetPersonId = "";
    /**
     * The IDs of the other people being merged into target_person_id. After the merge is completed, these person IDs will
     * no longer be valid.
     *
     * @generated from field: repeated string person_id = 1;
     */
    personId = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.MergePeopleRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "target_person_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 1, name: "person_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new MergePeopleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergePeopleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergePeopleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergePeopleRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.people.v1.MergePeopleResponse
 */
export class MergePeopleResponse extends Message {
    /**
     * @generated from field: string person_id = 1;
     */
    personId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.people.v1.MergePeopleResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new MergePeopleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergePeopleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergePeopleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergePeopleResponse, a, b);
    }
}
